/**
 * Client-side pre-flight for the change-password form. Keeps obviously bad
 * submissions off the network; the server re-validates and owns the
 * current-password check. Codes map to i18n messages in PasswordCard.
 */
export type PasswordFormError =
  | 'CURRENT_REQUIRED'
  | 'TOO_SHORT'
  | 'MISMATCH'
  | 'SAME_AS_CURRENT'
  | null;

export const PASSWORD_MIN_LENGTH = 8;

export function validatePasswordForm(input: {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}): PasswordFormError {
  if (input.currentPassword.length === 0) return 'CURRENT_REQUIRED';
  if (input.newPassword.length < PASSWORD_MIN_LENGTH) return 'TOO_SHORT';
  if (input.newPassword !== input.confirmPassword) return 'MISMATCH';
  if (input.newPassword === input.currentPassword) return 'SAME_AS_CURRENT';
  return null;
}
